/**********************************************************************
// @@@ START COPYRIGHT @@@
//        AVI SOLAR ENERGY CONFIDENTIAL: NEED TO KNOW ONLY
//        Copyright 2018 - 2019
//        Avi Solar Energy Pvt Ltd.
//        Protected as an unpublished work.
//  The computer program listings, specifications and documentation
//  herein are the property of Avi Solar Energy Pvt Ltd., or a third party supplier
//  and shall not be reproduced, copied, disclosed, or used in whole or in part for
//  any reason without the prior express written permission of Avi Solar Energy Pvt Ltd.
// @@@ END COPYRIGHT @@@
// +++ Code modified on 2019/02/25
**********************************************************************/
<template>
  <v-app >
    <v-navigation-drawer
       id="appDrawer"
      persistent
      :mini-variant="miniVariant"
      :clipped="clipped"
      v-model="drawer"
      hide-overlay
      enable-resize-watcher
      fixed
      app
    >

    <v-list class="pa-1">
        <v-list-tile v-if="miniVariant" @click.stop="miniVariant = !miniVariant">
          <v-list-tile-action>
            <v-icon>chevron_right</v-icon>
          </v-list-tile-action>
        </v-list-tile>
        <v-list-tile avatar tag="div">
          <v-list-tile-avatar>
            <img src="https://randomuser.me/api/portraits/men/85.jpg" >
          </v-list-tile-avatar>
          <v-list-tile-content>
            <v-list-tile-title>John Leider</v-list-tile-title>
          </v-list-tile-content>
          <v-list-tile-action>
            <v-btn icon @click.stop="miniVariant = !miniVariant">
              <v-icon>chevron_left</v-icon>
            </v-btn>
          </v-list-tile-action>
        </v-list-tile>
      </v-list>

     <v-list dense expand>
        <template v-for="(item, i) in menu_items">
            <!--group with subitems-->
            <v-list-group v-if="item.items" :key="item.name" :group="item.group" :prepend-icon="item.icon" no-action="no-action">
              <v-list-tile slot="activator" ripple="ripple">
                <v-list-tile-content>
                  <v-list-tile-title>{{ item.title }}</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
              <template v-for="(subItem, i) in item.items">
                <!--sub group-->
                <v-list-group v-if="subItem.items" :key="subItem.name" :group="subItem.group" sub-group="sub-group">
                  <v-list-tile slot="activator" ripple="ripple">
                    <v-list-tile-content>
                      <v-list-tile-title >{{ subItem.title }}</v-list-tile-title>
                    </v-list-tile-content>
                  </v-list-tile>
                  <v-list-tile v-for="(grand, i) in subItem.children" :key="i" :to="genChildTarget(item, grand)" :href="grand.href" ripple="ripple">
                    <v-list-tile-content>
                      <v-list-tile-title >{{ grand.title }}</v-list-tile-title>
                    </v-list-tile-content>
                  </v-list-tile>
                </v-list-group>
                <!--child item-->
                <v-list-tile v-else :key="i" :to="genChildTarget(item, subItem)" :href="subItem.href" :disabled="subItem.disabled" :target="subItem.target" ripple="ripple">
                  <v-list-tile-content>
                    <v-list-tile-title><span>{{ subItem.title }}</span></v-list-tile-title>
                  </v-list-tile-content>
                  <!-- <v-circle class="white--text pa-0 circle-pill" v-if="subItem.badge" color="red" disabled="disabled">{{ subItem.badge }}</v-circle> -->
                  <v-list-tile-action v-if="subItem.action">
                    <v-icon :class="[subItem.actionClass || 'success--text']">{{ subItem.action }}</v-icon>
                  </v-list-tile-action>
                </v-list-tile>
              </template>
            </v-list-group>
            <v-subheader v-else-if="item.header" :key="i">{{ item.header }}</v-subheader>
            <v-divider v-else-if="item.divider" :key="i"></v-divider>
            <!--top-level link-->
            <v-list-tile v-else :to="!item.href ? { name: item.name } : null" :href="item.href" ripple="ripple" :disabled="item.disabled" :target="item.target" rel="noopener" :key="item.name">
              <v-list-tile-action v-if="item.icon">
                <v-icon>{{ item.icon }}</v-icon>
              </v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-title>{{ item.title }}</v-list-tile-title>
              </v-list-tile-content>
              <!-- <v-circle class="white--text pa-0 chip--x-small" v-if="item.badge" :color="item.color || 'primary'" disabled="disabled">{{ item.badge }}</v-circle> -->
              <v-list-tile-action v-if="item.subAction">
                <v-icon class="success--text">{{ item.subAction }}</v-icon>
              </v-list-tile-action>
              <!-- <v-circle class="caption blue lighten-2 white--text mx-0" v-else-if="item.chip" label="label" small="small">{{ item.chip }}</v-circle> -->
            </v-list-tile>
        </template>
      </v-list>

    </v-navigation-drawer>
    <v-toolbar
      app
      :clipped-left="clipped"
        color="primary"
    >
      <v-toolbar-side-icon @click.stop="drawer = !drawer"></v-toolbar-side-icon>
      <!-- <v-btn icon @click.stop="miniVariant = !miniVariant">
        <v-icon v-html="miniVariant ? 'chevron_right' : 'chevron_left'"></v-icon>
      </v-btn> -->
      <!-- <v-btn icon @click.stop="clipped = !clipped">
        <v-icon>web</v-icon>
      </v-btn>
      <v-btn icon @click.stop="fixed = !fixed">
        <v-icon>remove</v-icon>
      </v-btn> -->
      <v-toolbar-title v-text="title"></v-toolbar-title>
      <v-spacer></v-spacer>

          <!-- <v-btn icon>
          <span slot="badge">6</span>

        <v-icon>notifications</v-icon>
      </v-btn> -->
      <v-badge left color="red">
      <span slot="badge">2</span>
      <v-icon  >notifications</v-icon>
    </v-badge>
     <v-btn icon @click="handleFullScreen()">
        <v-icon>fullscreen</v-icon>
    </v-btn>

         <v-menu offset-y origin="center center" :nudge-bottom="10" transition="scale-transition">
        <v-btn icon  large flat slot="activator">
          <v-list-tile-avatar size="40px">
            <img src="../../static/avatar/man_5.jpg" alt="Michael Wang"/>
          </v-list-tile-avatar>
        </v-btn>

         <v-list>
            <v-list-tile v-for="(item, index) in items2" :key="index">
               <v-list-tile-title>{{ item.title }}</v-list-tile-title>
            </v-list-tile>
          </v-list>

      </v-menu>

    </v-toolbar>

    <v-content>

      <router-view/>
    </v-content>
    <!-- Theme button -->
     <v-btn small fab falt fixed top="top" right="right" class="setting-fab" color="red"  @click.stop="rightDrawer = !rightDrawer">
          <v-icon>settings</v-icon>
        </v-btn>
    <!-- <v-navigation-drawer
      temporary
      :right="right"
      v-model="rightDrawer"
      fixed
      app
    >
      <v-list>
        <v-list-tile @click="right = !right">
          <v-list-tile-action>
            <v-icon>compare_arrows</v-icon>
          </v-list-tile-action>
          <v-list-tile-title>Switch drawer (click me)</v-list-tile-title>
        </v-list-tile>
      </v-list>
        <theme-settings></theme-settings>
    </v-navigation-drawer> -->
      <v-navigation-drawer
          class="setting-drawer"
          temporary
          right
          v-model="rightDrawer"
          hide-overlay
          fixed
          >
          <theme-settings></theme-settings>
        </v-navigation-drawer>
    <!-- <v-footer :fixed="fixed" app>
      <span>&copy; 2017</span>
    </v-footer> -->
  </v-app>
</template>

<script>
import ThemeSettings from '@/components/ThemeSettings'
import Util from '@/util'
import menu from '@/api/menu'
export default {
  name: 'App',
  components: {
    ThemeSettings
  },
  data () {
    return {
      clipped: true, // top bar
      drawer: true, // lef open or not
      fixed: false,
      items: [
        {
          icon: 'bubble_chart',
          title: 'Inspire'
        },
        {
          icon: 'bubble_chart',
          title: 'Inspire'
        }
      ],
      items2: [{ title: 'Profile' }, { title: 'Log Out' }],
      miniVariant: false,
      right: true,
      rightDrawer: false,
      title: 'EagleSun',
      theme: 'primary',
      menu_items: [
        { icon: 'lightbulb_outline', title: 'Notes' },
        { icon: 'touch_app', title: 'Reminders' },
        { divider: true },
        { heading: 'Labels' },
        { icon: 'add', title: 'Create new label' },
        { divider: true },
        { icon: 'archive', title: 'Archive' },
        { icon: 'delete', title: 'Trash' },
        { divider: true },
        { icon: 'settings', title: 'Settings' },
        { icon: 'chat_bubble', title: 'Trash' },
        { icon: 'help', title: 'Help' },
        { icon: 'phonelink', title: 'App downloads' },
        { icon: 'keyboard', title: 'Keyboard shortcuts' }
      ],
      menus: menu,
      scrollSettings: {
        maxScrollbarLength: 160
      },
      admins: [['Management', 'people_outline'], ['Settings', 'settings']],
      cruds: [
        ['Create', 'add'],
        ['Read', 'insert_drive_file'],
        ['Update', 'update'],
        ['Delete', 'delete']
      ]
    }
  },
  methods: {
    handleFullScreen () {
      Util.toggleFullScreen()
    },
    openThemeSettings () {
      this.$vuetify.goTo(0)
      this.rightDrawer = !this.rightDrawer
    },
    toolbarColor () {
      // return this.$vuetify.options.extra.mainNav;
    },
    genChildTarget (item, subItem) {
      if (subItem.href) return
      if (subItem.component) {
        return {
          name: subItem.component
        }
      }
      return { name: `${item.group}/${subItem.name}` }
    }
  },
  created: function () {
    this.toolbarColor()

    //  AppEvents.forEach(item => {
    //   this.$on(item.name, item.callback);
    // });
    // window.getApp = this;
  }
}
</script>

<style lang="stylus" scoped>
.setting-fab {
  top: 50% !important;
  right: 0;
  border-radius: 0;
}

.page-wrapper {
  min-height: calc(100vh - 64px - 50px - 81px);
}

@import '../../node_modules/vuetify/src/stylus/settings/_elevations.styl';
</style>
